import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Shield } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ReputationManagement() {
  usePageMeta({
    title: "ניהול מוניטין בגוגל: כך תשתלטו על התוצאות בחיפוש השם שלכם | upsite",
    description: "דואגים למה שגוגל אומר עליכם? אפסייט מתמחה בדחיקת תוצאות שליליות והבלטת המוניטין החיובי שלכם בתוצאות החיפוש. השתלטו על הנכס היקר ביותר שלכם, השם שלכם",
  });

  return (
    <ServicePageTemplate
      icon={Shield}
      title="ניהול מוניטין בגוגל"
      subtitle="ניהול מוניטין"
      description="המוניטין שלכם הוא הנכס הכי יקר שלכם. אנחנו מתמחים בניהול ושיפור התדמית הדיגיטלית שלכם – דחיקת תוצאות שליליות, הבלטת תוכן חיובי ושליטה במה שלקוחות רואים כשהם מחפשים אתכם בגוגל."
      benefits={[
        "דחיקת תוצאות שליליות בגוגל בשיטות אתיות",
        "בניית נוכחות חיובית חזקה בתוצאות החיפוש",
        "ניטור שוטף של המוניטין הדיגיטלי",
        "יצירת תוכן מקצועי שמחזק את המותג",
        "ניהול וטיפול בביקורות ותגובות",
        "אסטרטגיה מותאמת אישית לכל לקוח",
      ]}
      processSteps={[
        { title: "ניתוח מצב קיים", desc: "מיפוי מלא של תוצאות החיפוש הקשורות לשם שלכם או לעסק ואיתור נקודות בעייתיות." },
        { title: "בניית אסטרטגיה", desc: "תוכנית פעולה מפורטת לשיפור המוניטין – יצירת תוכן, בניית נכסים דיגיטליים חיוביים ודחיקת תוכן שלילי." },
        { title: "יישום ובנייה", desc: "יצירת תוכן איכותי, בניית פרופילים מקצועיים והגברת נוכחות חיובית ברשת." },
        { title: "ניטור ותחזוקה", desc: "מעקב שוטף אחר תוצאות החיפוש, התאמת אסטרטגיה ושמירה על מוניטין חיובי לאורך זמן." },
      ]}
    />
  );
}
